fragment EntitySummaryFragment on EntitySummaryInterface {
    id
    entityId
    status
    summary
    userRating
    createdTime
    userRating
    ... on LeadEntitySummary {
        isValid
        recap
        nextSteps
    }
}
